import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import { ImageView, View, ViewOpts } from '@play-co/timestep-core/ui';

/**
 * Create tier image
 */
export default class TierView {
  private view: FlexBoxView;
  private star: ViewOpts;

  /**
   * Create view
   */
  constructor(opts: ViewOpts & { star: ViewOpts }) {
    this.view = new FlexBoxView({
      ...opts,
      flex: {
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
      },
    });

    // Set max tier
    this.star = opts.star;
  }

  /**
   * Set tier
   */
  public setTier(tier: number, max: number) {
    // Remove all starts images
    this.getView().removeAllSubviews();

    // Create only enabled stars only
    for (let index = 0; index < tier; index++) {
      this.addStar(true);
    }

    // How many disabled stars
    const disabled = max - tier;

    // How many disabled stars
    for (let index = 0; index < disabled; index++) {
      this.addStar(false);
    }
  }

  /**
   * Create one star
   */
  private addStar(on: boolean) {
    return new ImageView({
      superview: this.getView(),
      ...this.star,
      image: on
        ? 'assets/ui/catalog/icons/star_grade.png'
        : 'assets/ui/catalog/icons/star_grade_empty.png',
    });
  }

  /**
   * Get view
   */
  public getView(): View {
    return this.view;
  }
}
